"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Product = void 0;
var _productBox = require("@ori/product-box");
var _react = require("react");
var _personalProductListEditContext = require("../../../../contexts/personalProductListEditContext");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const Product = (param)=>{
    let { product, onRemove } = param;
    const { productBoxConfiguration } = (0, _personalProductListEditContext.usePersonalProductListEditContext)();
    const onRemoveButtonClick = (0, _react.useCallback)(()=>{
        onRemove(product);
    }, [
        onRemove,
        product
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_productBox.ProductBox, {
        ...product,
        isLink: false,
        price: null,
        buttons: _constants.buttons,
        hideRating: !productBoxConfiguration.isRatingsAndReviewsEnabled,
        mrpStatementEnabled: productBoxConfiguration.isMrpStatementEnabled,
        withTranslationsProvider: false,
        labels: null,
        onRemoveButtonClick: onRemoveButtonClick
    });
};
exports.Product = Product;
